import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/pages/DashboardPage.css';
import { FaFileInvoice, FaBook, FaBalanceScale, FaRobot, FaFileAlt, FaReceipt, FaCashRegister, FaLock, FaUsers, FaBuilding, FaCreditCard, FaQuestionCircle, FaHandshake, FaWallet, FaList, FaFileInvoiceDollar, FaMoneyCheckAlt, FaSignOutAlt, FaCog, FaBolt, FaInbox, FaUniversity, FaTasks, FaFileSignature } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { getEstado as getEstadoFacturador } from '../services/facturadorService';

const DashboardPage = ({ company }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [facturadorActivo, setFacturadorActivo] = useState(false);

  // EFE activa el facturador por empresa: se consulta al entrar, así la tarjeta aparece sin volver a elegir la empresa
  useEffect(() => {
    getEstadoFacturador(company.id_company)
      .then((estado) => setFacturadorActivo(estado.activado === true))
      .catch(() => setFacturadorActivo(false));
  }, [company.id_company]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleSettings = () => {
    navigate('/configuracion');
  };

  return (
    <div className="dash">
      <header className="dash-header">
        <div className="dash-header-top">
          <h1 className="dash-title">{company.name}</h1>
          <div className="dash-header-actions">
            <a href="/manual-usuario.html" target="_blank" rel="noopener noreferrer" className="dash-manual-btn">
              <FaQuestionCircle /> Manual de usuario
            </a>
            <button onClick={handleSettings} className="dash-settings-btn">
              <FaCog /> Configuración
            </button>
            <button onClick={handleLogout} className="dash-logout-btn">
              <FaSignOutAlt /> Cerrar sesión
            </button>
          </div>
        </div>
        <p className="dash-sub">Panel de administración</p>
      </header>

      <section className="dash-section">
        <h2 className="dash-section-title">Compras</h2>
        <div className="dash-grid">
          <Card title="Facturas de compra" link="/carga-compras" icon={<FaFileInvoice />} />
        </div>
      </section>

      <section className="dash-section">
        <h2 className="dash-section-title">Ventas</h2>
        <div className="dash-grid">
          <Card title="Facturas de venta" link="/carga-ventas" icon={<FaFileAlt />} />
          <Card title="Boletas" link="/cargar-boletas-sii" icon={<FaReceipt />} />
          <Card title="Ventas POS" link="/comprobante-pago" icon={<FaCashRegister />} />
          <Card title="Medios de pago" link="/credenciales-medios-pago" icon={<FaCreditCard />} />
        </div>
      </section>

      <section className="dash-section">
        <h2 className="dash-section-title">Contabilidad</h2>
        <div className="dash-grid">
          <Card title="Asientos contables" link="/ingreso-manual" icon={<FaBook />} />
          <Card title="Ver asientos contables" link="/asientos-contables" icon={<FaList />} />
          <Card title="Visualizar balance" link="/ver-balance" icon={<FaBalanceScale />} />
          <Card title="Cierre mensual" link="/cierre-mensual" icon={<FaLock />} />
          <Card title="Cierre anual" link="/cierre-anual" icon={<FaLock />} />
          {/* Oculto temporalmente: aún faltan pruebas. No eliminar. */}
          {/* <Card title="Libro Caja SII" link="/libro-caja" icon={<FaWallet />} /> */}
          {/* <Card title="Libro Ingresos y Egresos SII" link="/libro-ingresos-egresos" icon={<FaList />} /> */}
          {company.conciliacion_bancaria && (
            <Card title="Conciliación Bancaria" link="/conciliacion-bancaria" icon={<FaUniversity />} />
          )}
        </div>
      </section>

      <section className="dash-section">
        <h2 className="dash-section-title">Gestión</h2>
        <div className="dash-grid">
          <Card title="Impuestos" link="/servicios-sii" icon={<FaRobot />} />
          {facturadorActivo && (
            <Card title="Facturación electrónica" link="/facturador" icon={<FaFileSignature />} />
          )}
          <Card title="Arriendos" link="/arriendos" icon={<FaBuilding />} />
          {company.recursos_humanos && (
            <Card title="Recursos Humanos" link="/rrhh" icon={<FaUsers />} />
          )}
          <Card title="Boletas de Honorarios" link="/retencion-honorarios" icon={<FaMoneyCheckAlt />} />
          <Card title="Socios empresa y Dividendos" link="/socios-dividendos" icon={<FaHandshake />} />
          <Card title="Patentes" link="/patentes" icon={<FaFileInvoiceDollar />} />
          <Card title="Acciones Rápidas" link="/acciones-rapidas" icon={<FaBolt />} />
          <Card title="Solicitudes de Clientes" link="/solicitudes" icon={<FaInbox />} variant="clientes" />
          <Card title="Control Clientes" link="/control-clientes" icon={<FaTasks />} variant="clientes" />
        </div>
      </section>
    </div>
  );
};

const Card = ({ title, link, icon, variant }) => (
  <Link to={link} className={`dash-card${variant ? ` dash-card--${variant}` : ''}`}>
    <span className="dash-card-icon">{icon}</span>
    <span className="dash-card-label">{title}</span>
  </Link>
);

export default DashboardPage;
